import React from 'react'
import PropTypes from 'prop-types'

const CollectInfo = ({ collectName, startingAt = null, ensembleName = '' }) => (
  <div className="mb-4 bg-white border p-3">
    <p className="mb-2">
      <strong>Collecte :</strong>
      {' '}
      {collectName}
      {startingAt ? (
        <span>
          {' '}
          (planification du
          {' '}
          {startingAt}
          )
        </span>
      ) : null}
    </p>
    <p className="mb-0">
      <strong>Ensemble :</strong>
      {' '}
      {ensembleName}
    </p>
  </div>
)

CollectInfo.propTypes = {
  collectName: PropTypes.string.isRequired
}

export default CollectInfo